import _ from "lodash";
import React, { useEffect } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { ToastContainer, toast, cssTransition } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import classes from "./SentralPortalModalCloseToast.scss";

const Message = () => (
  <div className={classNames(classes.container, "text-body-s")}>
    <Trans i18nKey="toastMsgs:sentral_portal_modal_close_mesage">
      Click the <div className={classes.shortcutChip}>Home</div> icon to close
      this modal.
    </Trans>
  </div>
);

const SentralPortalModalCloseToast = props => {
  const { showCloseToast } = props;

  useEffect(() => {
    const toastId = "sentral-portal-toast-message-id";
    if (showCloseToast) {
      toast(<Message />, {
        autoClose: false,
        className: classes.toastContainer,
        toastId,
        containerId: "sentral-portal-toast-message",
      });
    } else {
      toast.dismiss(toastId);
    }
  }, [showCloseToast]);

  const slideTransition = cssTransition({
    enter: classes.slideEnter,
    exit: classes.slideExit,
  });

  return (
    <ToastContainer
      hideProgressBar={true}
      closeButton={false}
      position={"bottom-center"}
      containerId="sentral-portal-toast-message"
      enableMultiContainer
      className={classes.toastWrapper}
      bodyClassName={classes.toastBody}
      transition={slideTransition}
    />
  );
};

const mapStateToProps = state => {
  const sentralPortalDetails = _.get(state, "login.sentralPortalDetails", {});
  const isVisible = _.get(sentralPortalDetails, "isVisible", false);
  const loader = _.get(sentralPortalDetails, "loader", false);
  const showCloseToast = isVisible && !loader;

  return {
    showCloseToast,
  };
};

export default connect(mapStateToProps, null)(SentralPortalModalCloseToast);
